import React from 'react';
import { useBargain } from 'app/BargainWidget/context/BargainContext';
import { darkenHexColor } from 'app/BargainWidget/Bargains/utils/common-utils';

const MakeAnOfferButton = ({ className = '', onClick }) => {
  const { translation, widgetSettings } = useBargain();

  return (
    <button
      id="bargain-make-an-offer-button"
      style={
        {
          '--make-an-offer-button-background-color': widgetSettings?.offerButtonColor || '#000000',
          '--make-an-offer-button-hover-background-color': darkenHexColor(widgetSettings?.offerButtonColor || '#000000', 5),
          '--make-an-offer-button-ring-color': darkenHexColor(widgetSettings?.offerButtonColor || '#000000', 3),
          '--make-an-offer-button-text-color': widgetSettings?.buttonTextColor || '#ffffff',
        } as any
      }
      className={`se-w-full se-max-w-[440px] se-bg-[var(--make-an-offer-button-background-color)] se-text-[var(--make-an-offer-button-text-color)] hover:se-bg-[var(--make-an-offer-button-hover-background-color)] se-flex se-justify-center se-items-center se-p-3 se-cursor-pointer se-font-inherit se-no-underline se-tracking-wider se-leading-[calc(1+.2/1)] se-border-0 se-rounded-md
        se-transition-colors se-duration-300 focus:se-outline-none focus:se-ring-2 focus:se-ring-[var(--make-an-offer-button-ring-color)] bargain-make-an-offer-button ${className}`}
      type="button"
      onClick={onClick}
    >
      <span id="bargain-make-an-offer-button-text" className="se-ml-1">
        {translation?.makeAnOfferButtonLabel || 'Make an offer'}
      </span>
    </button>
  );
};

export default MakeAnOfferButton;
